// extracted by mini-css-extract-plugin
export default {"wrapperShops":"Shops_wrapperShops__tTjNc","listShops":"Shops_listShops__5BSK4","link":"Shops_link__rKZuj"};